/** AU states shown in contractor service area UI */
export const CONTRACTOR_STATE_CODES = [
    'NSW',
    'QLD',
    'VIC',
    'ACT',
    'SA',
    'WA',
    'NT',
    'TAS',
] as const;

export type ContractorAuState = (typeof CONTRACTOR_STATE_CODES)[number];

export const CONTRACTOR_STATE_LONG_LABEL: Record<string, string> = {
    NSW: 'New South Wales',
    QLD: 'Queensland',
    VIC: 'Victoria',
    ACT: 'Australian Capital Territory',
    SA: 'South Australia',
    WA: 'Western Australia',
    NT: 'Northern Territory',
    TAS: 'Tasmania',
};

export function contractorStateTitle(code: string): string {
    const long = CONTRACTOR_STATE_LONG_LABEL[code] ?? code;
    return `${long} (${code})`;
}
